import './StatusBadge.scss';

export const StatusBadge = ({
  status,
  releaseStatus,
}: {
  status: string;
  releaseStatus?: string;
}) => {
  // An in-progress release takes precedence over the maintenance status so the badge
  // reads "In Progress"; once the release is LIVE it falls back to the maintenance status.
  const effectiveStatus =
    releaseStatus?.toUpperCase() === 'IN_PROGRESS' ? 'in_progress' : status;
  const normalizedStatus = effectiveStatus.toLowerCase();

  const statusObj: { [key: string]: string } = {
    active: 'Active',
    deprecated: 'Deprecated',
    inactive: 'Inactive',
    // eslint-disable-next-line camelcase -- key matches the normalized IN_PROGRESS API status
    in_progress: 'In Progress',
  };

  return (
    <div className={`status-badge status-badge__${normalizedStatus}`}>
      {statusObj[normalizedStatus]}
    </div>
  );
};
